import { createTheme } from "@material-ui/core/styles";

const theme = createTheme({
    palette: {
      primary: {
        main: "#FA292C",
      },
      secondary: {
        main: '#FA292C',
      },
      loaderColor:{
        main: "#7685DA"
      }
    },
  });

  export default theme;